import { createSlice } from "@reduxjs/toolkit"

  export const popupSlice = createSlice({
    name: 'popup',
    initialState:{
      popupList:[],
      autoPopups:[],
      triggerPopups:[],
      announcementModal:{open:false,content:null, onApprove:null}
    },
    reducers: {
      setPopupList:(state, action) => {
        state.popupList = action.payload
        state.autoPopups = action.payload.filter(popup => popup.trigger == 0)
        state.triggerPopups = action.payload.filter(popup => popup.trigger == 1)
      },
      setAnnouncementModal:(state, action) => {
        state.announcementModal = action.payload
        if (action.payload.onApprove !== null) {
          const onApprove = action.payload.onApprove;
          state.announcementModal.onApprove = () => {
            onApprove();
          };
        }
      }
    },
  })
  
  export const { setPopupList, setAnnouncementModal } = popupSlice.actions
  
  export default popupSlice.reducer